import { APPCONFIG } from '@config/app.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { ErrorHandler } from '@helper/errorHandler';
import { SecondaryClub } from '@components/endUserDetails/components/kycDetailsForm';
export const useKaeSecondaryClubQuery = (kaeClubId: string | null): IQueryResponse<SecondaryClub[]> => {
	const fetchSecondaryClub = async (): Promise<SecondaryClub[]> => {
		try {
			const url = `${APPCONFIG.baseUrl}/apis/v.3.0/wwa/secondary-club-dropdown/?limit=0&kaeclub_c=${kaeClubId}`;
			return await APIService.getData<SecondaryClub[]>(url);
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['secondaryClub', kaeClubId],
		queryFn: fetchSecondaryClub,
		enabled: !!kaeClubId,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
